
import React from 'react';
import { format } from 'date-fns';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Lead } from '@/types/lead';
import { getStatusDisplayInfo } from '@/services/leads/leadStatus';

interface RecentLeadsTableProps {
  leads: Lead[];
}

const RecentLeadsTable: React.FC<RecentLeadsTableProps> = ({ leads }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Leads</CardTitle>
        <CardDescription>Your most recently added leads</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Category</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-right">Added On</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {leads.slice(0, 10).map((lead) => {
              const statusInfo = getStatusDisplayInfo(lead.status);
              return (
                <TableRow key={lead.id}>
                  <TableCell className="font-medium">{lead.name}</TableCell>
                  <TableCell>{lead.category || 'N/A'}</TableCell>
                  <TableCell>
                    <Badge className={`${statusInfo.color} text-white`}>
                      {statusInfo.label}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right">
                    {format(lead.createdAt, 'MMM d, yyyy')}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default RecentLeadsTable;
